// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__36kJh","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3fCom"};